module.exports = __webpack_public_path__ + "assets/images/vcr_restaurant-02.9eefaf4f62cf3a0323bbb9306762a1c3.svg";